module.exports = new __parcel__URL__("speed-pitch-sliders.0b5f83b5.png").toString();